// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { Analytics, getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import jwtDecode from "jwt-decode";
import jwt_decode from "jwt-decode";

// import { aliasPlatform } from "../../utils/helper";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
let analytics: Analytics;
const firebaseConfig = {
  development: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
  fnb: {
    apiKey: process.env.REACT_APP_FIREBASE_FNB_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_FNB_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_FNB_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_FNB_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_FNB_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_FNB_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_FNB_MEASUREMENT_ID,
  },
  weborder: {
    apiKey: process.env.REACT_APP_FIREBASE_FNB_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_FNB_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_FNB_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_FNB_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_FNB_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_FNB_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_FNB_MEASUREMENT_ID,
  },
  retail: {
    apiKey: process.env.REACT_APP_FIREBASE_RETAIL_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_RETAIL_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_RETAIL_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_RETAIL_STORAGE_BUCKET,
    messagingSenderId:
      process.env.REACT_APP_FIREBASE_RETAIL_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_RETAIL_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_RETAIL_MEASUREMENT_ID,
  },
  kiotonline: {
    apiKey: process.env.REACT_APP_FIREBASE_KIOTONLINE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_KIOTONLINE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_KIOTONLINE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_KIOTONLINE_STORAGE_BUCKET,
    messagingSenderId:
      process.env.REACT_APP_FIREBASE_KIOTONLINE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_KIOTONLINE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_KIOTONLINE_MEASUREMENT_ID,
  },
  booking: {
    apiKey: process.env.REACT_APP_FIREBASE_BOOKING_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_BOOKING_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_BOOKING_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_BOOKING_STORAGE_BUCKET,
    messagingSenderId:
      process.env.REACT_APP_FIREBASE_BOOKING_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_BOOKING_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_BOOKING_MEASUREMENT_ID,
  },
  hotel: {
    apiKey: process.env.REACT_APP_FIREBASE_HOTEL_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_HOTEL_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_HOTEL_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_HOTEL_STORAGE_BUCKET,
    messagingSenderId:
      process.env.REACT_APP_FIREBASE_HOTEL_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_HOTEL_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_HOTEL_MEASUREMENT_ID,
  },
};

const createFirebaseAnalytic = (platform: string, retailerId : string) => {
  if (process.env.NODE_ENV !== "production") {
    return initializeFirebaseAnalytic(firebaseConfig.development, retailerId);
  }
  if (Object.keys(firebaseConfig).includes(platform)) {
    const configWithPlatform =
      firebaseConfig[platform as "fnb" | "retail" | "kiotonline" | "weborder" | "booking" | "hotel"];
    return initializeFirebaseAnalytic(configWithPlatform, retailerId);
  }
  return null;
};

const initializeFirebaseAnalytic = (config: any, retailerId : string) => {
  if (analytics) {
    return;
  }
  const app = initializeApp(config);
  analytics = getAnalytics(app);
  //add user property
  if(retailerId){
    setUserProperties(analytics, {tid: retailerId})
  }
  return analytics;
};

const firebaseLog = (
  eventName: string,
  eventParams?: {
    value?: any;
    [key: string]: any;
  }
) => {

  // tên event theo môi trường
  const domain = window.location.hostname;
  let eventNameByPlatformAndEnv = eventName;
  if(domain.includes('.dev-') || domain.includes('localhost')){ // mt dev
    eventNameByPlatformAndEnv = `dev_${eventParams?.platform}_${eventName}`;
  } else if(domain.includes('.stg-')) { // mt staging
    eventNameByPlatformAndEnv = `staging_${eventParams?.platform}_${eventName}`;
  }

  if(analytics){
    logEvent(analytics, eventNameByPlatformAndEnv, eventParams);
  }

  const accessTokenLocal = localStorage.getItem('mykiot_access_token')
  if(accessTokenLocal){
    if(eventParams && typeof eventParams?.platform !== 'undefined' && eventParams?.platform === 'retail'){
      const jwtDecode: { [key: string]: any } = jwt_decode(accessTokenLocal)
      eventParams.retailerId = jwtDecode?.kvrid
    }
    const dataTrackingLog = {
      source: "m_tracking",
      eventName: eventNameByPlatformAndEnv,
      params: eventParams,
    };

    try {
      window && window.parent.postMessage(JSON.stringify(dataTrackingLog), "*");
    } catch (error) {}
  }

};
const firebaseIframeLog = (
  eventName: string,
  eventParams?: {
    value?: any;
    [key: string]: any;
  }
) => {
  const dataTrackingLog = {
    source: "m_tracking",
    eventName: eventName,
    params: eventParams,
  };
  try {
    window && window.parent.postMessage(JSON.stringify(dataTrackingLog), "*");
  } catch (error) {}
};

export { analytics, createFirebaseAnalytic, firebaseLog, firebaseIframeLog };
